import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { MentorLocalizationContext } from 'src/mentor/context/MentorLocalizationContext'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import ClinicOwnerReport from '../ClinicOwnerReport/ClinicOwnerReport'
import MentorHeader from '../MentorHeader'
import { HomePageContainer, HomePageItem } from './MentorHomepageStyles'

export default function MentorHomePage() {
  const navigate = useNavigate()
  const localizedData = useContext(MentorLocalizationContext)
  const { mentorProfileData, allLegalPolicies, mentorClinicAssociationData, portalViewSettings } =
    useContext(MentorProfileContext)
  const offersLive = mentorProfileData?.services?.live

  const showPayoutReports = mentorProfileData?.teacherUnEditableFields?.showPayoutReports
  const showEngagementModels = mentorProfileData?.teacherUnEditableFields?.showFeeModels

  const unAcceptedAgreements = allLegalPolicies?.filter((agreement) => !agreement?.signed)?.length
  const translatedStrings = localizedData?.localizedData?.strings?.homePage

  const hidePayoutReports = false

  console.log({ mentorProfileData })

  return (
    <>
      <MentorHeader
        greetingsEnabled={true}
        agreements={unAcceptedAgreements}
        translatedStrings={translatedStrings}
      />
      <HomePageContainer>
        {/* medicine database also*/}

        {mentorClinicAssociationData && mentorClinicAssociationData?.length > 0 ? (
          <HomePageItem
            otherColor="linear-gradient(46deg, #97271f 0%, #ff5f35 100%)"
            onClick={() => navigate('/mentor-home/my-clinic-associations')}
          >
            {translatedStrings?.clinic_bookings || 'EMR Checkin - Bookings'}
          </HomePageItem>
        ) : (
          <HomePageItem
            otherColor="linear-gradient(46deg, #97271f 0%, #ff5f35 100%)"
            onClick={() => navigate('/aumhum-for-clinics')}
          >
            {'Create your own clinic brand'}
          </HomePageItem>
        )}
        <HomePageItem
          otherColor="linear-gradient(46deg, #97271f 0%, #ff5f35 100%)"
          onClick={() => navigate('/mentor-home/upcoming-appointments')}
        >
          {'Upcoming Appointments'}
        </HomePageItem>

        {/* {mentorClinicAssociationData && mentorClinicAssociationData?.length > 0 && (
          <HomePageItem
            otherColor="linear-gradient(46deg, #18411f 0%, #ff5f35 100%)"
            onClick={() => navigate('/mentor-home/join-chamber-room')}
          >
            {'Clinic - Remotely Connect (Screenings)'}
          </HomePageItem>
        )} */}

        {/* {mentorClinicAssociationData && mentorClinicAssociationData?.length > 0 && (
          <HomePageItem
            otherColor="linear-gradient(46deg, #34ebb7 0%, #418571 100%)"
            onClick={() => navigate('/mentor-home/audit-chamber-room')}
          >
            {'Audit Chamber Room (Beta)'}
          </HomePageItem>
        )} */}

        {getAllRolesInBoolean().isDoctor && mentorProfileData?.allowedToPrescribe && (
          <HomePageItem
            otherColor="linear-gradient(46deg, #223948 0%, #4639a2 100%)"
            onClick={() => navigate('/mentor-home/prescription-templates')}
          >
            {translatedStrings?.prescription_templates || 'Prescription Pads'}
          </HomePageItem>
        )}

        {offersLive && (
          <HomePageItem onClick={() => navigate('/mentor-home/my-calendar')}>
            {translatedStrings?.booked_sessions_and_calendar_settings ||
              'Booked Sessions and Calendar Settings'}
          </HomePageItem>
        )}

        {/* {!!mentorProfileData?.services?.groupLive && (
          <HomePageItem
            otherColor="linear-gradient(46deg, #4f340d 0%, #B88B4A 100%)"
            onClick={() => navigate('/mentor-home/webinars')}
          >
            {translatedStrings?.webinars || 'Webinars'}
          </HomePageItem>
        )}  */}
        <HomePageItem
          otherColor="linear-gradient(46deg, #000 0%, #00FFB2 100%)"
          onClick={() => navigate('/mentor-home/profile')}
        >
          {translatedStrings?.my_profile || 'My Profile'}
        </HomePageItem>

        {mentorProfileData.services.recorded &&
          mentorProfileData.contentCategories.includes('activity-plan') && (
            <HomePageItem
              otherColor="linear-gradient(46deg, #222848 0%, #4639a2 100%)"
              onClick={() => navigate('/mentor-home/homework-plans/')}
            >
              {translatedStrings?.faqs || 'Homework Plans'}
            </HomePageItem>
          )}

        {/* {getAllRolesInBoolean().isDoctor && ( */}
          <HomePageItem
            otherColor="linear-gradient(46deg, #749da6 0%, #4EC3C4 100%)"
            onClick={() => navigate('/mentor-home/settings')}
          >
            {translatedStrings?.emr_settings || 'EMR Settings'}
          </HomePageItem>

        <HomePageItem
          otherColor="linear-gradient(46deg, #4f340d 0%, #B88B4A 100%)"
          onClick={() => navigate('/mentor-home/faqs')}
        >
          {translatedStrings?.faqs || 'FAQs'}
        </HomePageItem>

        {allLegalPolicies?.length > 0 && (
          <HomePageItem
            otherColor="linear-gradient(46deg, #000 0%, #939393 100%)"
            onClick={() => navigate('/mentor-home/agreements')}
          >
            {translatedStrings?.agreements_tax_and_banking || 'Agreements, Tax and Banking'}
          </HomePageItem>
        )}
        {getAllRolesInBoolean().isTeacher && !!showPayoutReports && (
          <HomePageItem
            otherColor="linear-gradient(46deg,rgb(22, 35, 6) 0%, #41ac51 100%)"
            onClick={() => navigate('/mentor-home/payout-invoices')}
          >
            {'Your Payout Invoices'}
          </HomePageItem>
        )}
        {getAllRolesInBoolean().isTeacher && !!showPayoutReports && (
          <HomePageItem
            otherColor="linear-gradient(46deg, #133320 0%, #41ac51 100%)"
            onClick={() => navigate('/mentor-home/payout-reports')}
          >
            {'Your Payout Reports'}
          </HomePageItem>
        )}

        {getAllRolesInBoolean().isTeacher && !!showEngagementModels && (
          <HomePageItem
            otherColor="linear-gradient(46deg, #133320 0%, #41ac51 100%)"
            onClick={() => navigate('/mentor-home/engagement-models')}
          >
            {'Engagement Models'}
          </HomePageItem>
        )}

        {/* to be brought into MP */}
        {/* {mentorClinicAssociationData && mentorClinicAssociationData?.length > 0 && (
          <HomePageItem
            onClick={() => navigate('/clinic-home')}
            otherColor="linear-gradient(46deg, #9098a5 0%, #4639a2 100%)"
          >
            {translatedStrings?.clinic_bookings ||
              'Go to Clinic Portal (History, Communications and more)'}
          </HomePageItem>
        )} */}

        {/* {offersLive && (
          <HomePageItem
            otherColor="linear-gradient(46deg, #5c5439 0%, #29f9ff 100%)"
            onClick={() => navigate('/booking-requests-for-mentors/active')}
          >
            {translatedStrings?.booking_requests || 'Booking Requests'}
          </HomePageItem>
        )} */}
      </HomePageContainer>
      <div style={{ padding: '32px 8px', width: '100%' }}>
        {getAllRolesInBoolean().isClinicOwner && <ClinicOwnerReport />}
      </div>
    </>
  )
}
